"use client";

import { useContext, useEffect } from "react";
import Sidenav from "../components/sidenav";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import BottomNav from "../components/global/BottomNav";
import ChangeTheme from "../components/global/ChangeTheme";
import { ThemeContext } from "../context/ThemeStore";
import UserAuthProfile from "../components/global/UserAuthProfile";

const useQuery = () => new URLSearchParams(useLocation().search);
const Dashboard = ({ children }) => {
  const query = useQuery();
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(ThemeContext);
  const isLms = sessionStorage.getItem("lms");

  // Check if we're on profile/settings pages
  const isProfilePage = location.pathname.includes("/account/") || location.pathname.includes("/profile");

  const isSolutionsPage = () => {
    const solutionsPattern = /^\/solutions\/.*$/;
    return solutionsPattern.test(location.pathname);
  };

  const handleAuthRedirect = () => {
    const params = new URLSearchParams();

    const utmSource = query.get("utm_source");
    const utmMedium = query.get("utm_medium");
    const utmCampaign = query.get("utm_campaign");
    if (utmSource) params.append("utm_source", utmSource);
    if (utmMedium) params.append("utm_medium", utmMedium);
    if (utmCampaign) params.append("utm_campaign", utmCampaign);

    const queryString = params.toString();
    navigate(`/auth/login${queryString ? `?${queryString}` : ""}`);
  };

  useEffect(() => {
    if (!Cookies.get("token") && !sessionStorage.getItem("token")) {
      handleAuthRedirect();
    }
    const user = JSON.parse(localStorage.getItem("userProfile"));
    if (user && !user.isOnboardingDone && !isLms) navigate(`/onboarding?step=1`);
  }, []);

  return (
    <div className={isProfilePage ? "min-h-screen bg-[var(--q3-surface-default)]" : ""}>
      <UserAuthProfile />
      {!isLms && !isProfilePage && <Sidenav />}
      <ChangeTheme isLms={isLms} />
      <div className={`${isProfilePage ? "" : "main-content mb-5 mb-sm-0 pb-4 pb-sm-0"}`}>{children}</div>
      {!isLms && !isSolutionsPage() && !isProfilePage && <BottomNav />}
    </div>
  );
};

export default Dashboard;
